exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home2[data-v-7f198256]{text-align:left}.min-input-class[data-v-7f198256]{min-height:25px;border-bottom:1px dotted #b0b1b3}.div_title_question_all[data-v-7f198256]{padding-top:2px;font-size:15px;color:#444;font-weight:700;height:auto;line-height:20px;position:relative}", ""]);

// exports
